import { List, Map, Record, RecordOf } from 'immutable';

import { SLOT_FAMILY } from 'app/constants/matchCenterStakes';
import type { SupportedLang } from 'app/lang';

import type { RecordOfStakeEntity } from './betting/betting-entities';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;
// eslint-disable-next-line @typescript-eslint/ban-types
type FunctionType = Function;

export interface SlotEntryType {
  id?: string | number;
  type?: number;
  family?: SLOT_FAMILY;
  index?: number;
  sequencer: null | FunctionType;
  params: Map<string, AnyType>;
  stakes: List<RecordOfStakeEntity>;
  favorite: boolean;
  getSlotName: (lang: SupportedLang) => string;
}

export const SlotEntry = Record<SlotEntryType>(
  {
    id: undefined,
    type: undefined,
    family: undefined,
    getSlotName: () => '--',
    index: undefined,
    sequencer: null,
    params: Map(),
    stakes: List(),
    favorite: false,
  },
  'SlotEntry',
);

export type RecordOfSlotEntryType = RecordOf<SlotEntryType>;
